import React, { useState } from 'react';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState, Text } from '@common/components';
import { Button, Tooltip } from 'antd';
import { AssignmentOnboardingDueDateModal } from '@working-experience/components';
import { WorksListDueDateQuery } from '@working-experience/graphql/queries';
import { toUSFormat } from 'works/legacy/lib/date-helper';

export const AssignmentOnboardingDueDate = ({
  worksListId,
}: {
  worksListId: string;
}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const { data, error, loading } = useQuery(WorksListDueDateQuery, {
    variables: { id: worksListId },
  });

  if (error) {
    return <ErrorHandler error={error} log="AssignmentOnboardingDueDate" />;
  }

  if (loading) {
    return <LoadingState size="md" />;
  }

  const worksList = data?.worksList;
  const deadlineDueDate = worksList?.deadlineDueDate;
  const overrideDeadlineDetails = worksList?.deadlineDetails;
  const templateDeadlineDetails =
    worksList?.worksListTemplate?.complianceDeadlineDetails;

  const finalDeadlineDetails =
    overrideDeadlineDetails || templateDeadlineDetails;

  const canUpdateWorksList = worksList?.canUpdateDeadlineDueDate?.value;

  return (
    <>
      <AssignmentOnboardingDueDateModal
        visible={modalOpened}
        worksListId={worksListId}
        deadlineDueDate={deadlineDueDate}
        deadlineDetails={finalDeadlineDetails}
        onClose={() => setModalOpened(false)}
      />
      <div className="assignment-due-date">
        Due:{' '}
        <DeadlineDueDateContent
          deadlineDueDate={deadlineDueDate}
          hasUpdatePermission={canUpdateWorksList}
          templateDeadlineDetails={finalDeadlineDetails}
          onClick={() => setModalOpened(true)}
        />
      </div>
    </>
  );
};

const DeadlineDueDateContent = ({
  deadlineDueDate,
  hasUpdatePermission,
  templateDeadlineDetails,
  onClick,
}: {
  hasUpdatePermission?: boolean;
  deadlineDueDate?: string;
  templateDeadlineDetails?: string;
  onClick: () => void;
}) => {
  if (hasUpdatePermission) {
    return (
      <Tooltip
        overlayInnerStyle={{ width: 260 }}
        title={templateDeadlineDetails}
      >
        <Button type="link" style={{ paddingLeft: 0 }} onClick={onClick}>
          <Text weight="bold" color="elm">
            {deadlineDueDate ? toUSFormat(deadlineDueDate) : '+ Add Date'}
          </Text>
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={templateDeadlineDetails} overlayInnerStyle={{ width: 260 }}>
      {deadlineDueDate ? toUSFormat(deadlineDueDate) : 'N/A'}
    </Tooltip>
  );
};
